import { gql } from '@apollo/client';

const GET_EXECUTIVE_SUMMARY_REPORT = gql`
  query GetExecutiveSummaryReport($orgId: Int!) {
    executiveSummaryReport(orgId: $orgId) {
      OrgId
      Organization {
        Name
      }
      Commentary
      TotalUnitCount
      Demographic {
        OhtPercentages {
          Name
          Value
        }
        DeviceClassPercentages {
          Name
          Value
        }
      }
      Locations {
        LocationId
        Rank
        OrgUnits {
          Name
          Fei
        }
      }
      Summary {
        MostCommonLocations {
          LocationName
          Percentage
        }
        HighestOhts {
          Name
          Value
        }
        HighestDeviceClasses {
          Name
          Value
        }
        YearsInVip
        Strengths {
          Acronym
          GroupLevel
          NumberWithinLevel
          AggregatePercentage
        }
        Challenges {
          Acronym
          GroupLevel
          NumberWithinLevel
          AggregatePercentage
        }
      }
      Timeline {
        Type
        TimelineDate
        Spacing
        OrgUnits {
          ParticipationYears
          Units {
            Name
            Fei
          }
        }
      }
    }
  }
`;

export default GET_EXECUTIVE_SUMMARY_REPORT;
